import React from 'react'
import { Router, Switch, Route } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import { flyerBasePathWithoutPage } from 'app/routes'
import GenericRoute from 'splash/routes/generic.route'
import FlyerRoute from 'splash/routes/flyer.route'

const history = createBrowserHistory()

const SplashRoutes = () => (
  <Router history={history}>
    <Switch>
      <Route path={flyerBasePathWithoutPage} component={FlyerRoute} />
      <Route component={GenericRoute} />
    </Switch>
  </Router>
)

export default React.memo(SplashRoutes)
